module.exports = __webpack_public_path__ + "static/img-hexapod-desktop-hr@2x-1159ca96a2af31ec02c0c207d17583ac.jpg";